module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Цель нашего проекта — экономия времени исследователей, аспирантов и студентов при формировании списка источников научной статьи, дипломоной работы или диссертации.\n        Такие ресурсы, как E-Library.ru, содержат полную библиографическую информацию о статьи.\n        Но увы, оформление этой информации в соответствии с требованиями ГОСТ может занять очень много времени.\n        Наша система берет данные статьи из E-library, форматирует их в соовтетствии с шаблоном, отвечающим требованиям ГОСТ.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Современному исследователю часто приходится давать ссылки на материалы сети Интернет, не оформленные в виде научной статьи. Подобные ссылки оформляются в соответствии с ГОСТ весьма неочевидным способом. Для упрощения форматирования таких ссылок у нас предусмотрен пункт «Ссылка на электронный ресурс». С сожалению, не представляется возможным автоматически определить имя автора публикации. Поэтому, если вы знаете имя автора, укажите его, нажав кнопку «Дополнительно».\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n      В будущем мы предполагаем развить данный проект в полноценный редактор научных статей, который помимо ссылок будет упрощать и оформления самих статей. Вы можете ознакомиться с пробной версией редактора на соответствующей "), _c('router-link', {
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("странице")]), _vm._v(".\n    ")], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        ArtJump — автоматический генератор ссылок по ГОСТ онлайн\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_vm._v("\n      Если вы заметили неточность, либо просто хотите поделиться мыслями и предложениями по развитию проекта, вы можете оставить отзыв на соответствующей "), _c('a', {
    attrs: {
      "href": "http://art-jump.reformal.ru/proj/"
    }
  }, [_vm._v("странице")]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3065a8da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutPage.vue
// module id = 1002
// module chunks = 1